<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import MacroQueueItem from './MacroQueueItem.vue';
import SidebarActionsHeader from 'dashboard/components-next/SidebarActionsHeader.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

const { t } = useI18n();
const store = useStore();
const { updateUISettings } = useUISettings();

// Buscar execuções do store
const executions = useMapGetter('macroExecutions/getExecutions');
const activeCount = useMapGetter('macroExecutions/getActiveCount');

// Verificar se há execuções
const hasExecutions = computed(() => executions.value.length > 0);
const hasActiveExecutions = computed(() => activeCount.value > 0);

// Fechar o painel
const closePanel = () => {
  updateUISettings({
    is_macro_queue_open: false,
  });
};

// Limpar completadas
const clearCompleted = () => {
  store.dispatch('macroExecutions/clearCompleted');
};
</script>

<template>
  <div class="w-full h-full flex flex-col">
    <SidebarActionsHeader
      :title="$t('MACRO_QUEUE.TITLE')"
      @close="closePanel"
    />
    
    <div class="flex-1 overflow-y-auto px-4 pb-4">
      <!-- Lista de execuções -->
      <div v-if="hasExecutions" class="flex flex-col gap-3">
        <MacroQueueItem
          v-for="execution in executions"
          :key="execution.id"
          :execution="execution"
        />
      </div>
      
      <!-- Estado vazio -->
      <div 
        v-else
        class="flex flex-col items-center justify-center h-full text-center py-8"
      >
        <div class="w-16 h-16 rounded-full bg-n-alpha-2 flex items-center justify-center mb-4">
          <span class="i-lucide-list-checks w-8 h-8 text-n-slate-10" />
        </div>
        <p class="text-sm font-medium text-n-slate-12 mb-1">
          {{ $t('MACRO_QUEUE.EMPTY.TITLE') }}
        </p>
        <p class="text-xs text-n-slate-11 max-w-48">
          {{ $t('MACRO_QUEUE.EMPTY.DESCRIPTION') }}
        </p>
      </div>
    </div>
    
    <!-- Footer com ações -->
    <div 
      v-if="hasExecutions && !hasActiveExecutions" 
      class="px-4 py-3 border-t border-n-weak/50"
    >
      <button
        class="w-full text-sm text-n-slate-11 hover:text-n-slate-12 transition-colors"
        @click="clearCompleted"
      >
        {{ $t('MACRO_QUEUE.CLEAR_COMPLETED') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
/* Scrollbar personalizada */
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: transparent;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: rgba(100, 116, 139, 0.3);
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background-color: rgba(100, 116, 139, 0.5);
}
</style>
